import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import userApi from '../../api/userApi';
import { toast } from 'react-toastify';


const ChangeUserName = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [newUserName, setNewUserName] = useState(localStorage.getItem("userName") || "");

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!newUserName.trim()) {
            toast.error(t('common.username_change_failed'));
            return;
        }

        setLoading(true);
        try {
            const response = await userApi.changeUserName({
                newUserName: newUserName
            });
            toast.success(t('common.username_changed_success'));
            localStorage.setItem("userName", response.data.userName);
            // Optional: refresh page or state to update Header
            window.location.reload(); 
        } catch (error) {
            toast.error(error.response?.data?.message || t('common.username_change_failed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-[400px]">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle className="text-center">{t('common.change_username')}</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="newUserName">{t('common.new_username')}</Label>
                            <Input
                                id="newUserName"
                                type="text"
                                value={newUserName}
                                onChange={(e) => setNewUserName(e.target.value)}
                                required
                            />
                        </div>
                        <Button type="submit" className="w-full" disabled={loading}>
                            {loading ? t('common.saving') : t('common.save')}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};

export default ChangeUserName;
